export var GET_ORDER_BOOK = "GET_ORDER_BOOK";
export var GET_CO_ORDER_BOOK = "GET_CO_ORDER_BOOK";
export var GET_MF_ORDER_BOOK = "GET_MF_ORDER_BOOK";
export var GET_NFO_ORDER_BOOK = "GET_NFO_ORDER_BOOK";
export var GET_IPO_ORDER_BOOK = "GET_IPO_ORDER_BOOK";
export var GET_NCD_IPO_ORDER_BOOK = "GET_NCD_IPO_ORDER_BOOK";
export var GET_MFH_ORDER_BOOK = "GET_MFH_ORDER_BOOK";
export var GET_EQSIP_ORDER_BOOK = "GET_EQSIP_ORDER_BOOK";
export var GET_MFSIP_ORDER_BOOK = "GET_MFSIP_ORDER_BOOK";
